<template>
  <div class="modal order-modal" @click="$parent.closeCheckoutModal">
    <div class="overlay" @click="$parent.closeCheckoutModal"></div>
    <div class="wrapper" @click.stop>
      <div class="container">
        <div class="form">
          <div class="form-wrapper checkout-wrapper">
            <img class="close" @click="$parent.closeCheckoutModal" src="./../images/close.svg" />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="modal-top checkout-head">
                  <div class="checkout-head__side"></div>
                  <div class="title medium payment-title checkout-head__title">{{ $t('CHECKOUT') }}</div>
                  <div class="title small checkout-total checkout-head__side checkout-head__total">{{ currency }} {{ totalAmount }}</div>
                </div>

                <div class="fields">
                  <label>
                    <span class="desc">{{ $t('FIRST NAME') }}</span>
                    <input type="text" v-model="name" :placeholder="$t('First Name')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('LAST NAME') }}</span>
                    <input type="text" v-model="surname" :placeholder="$t('Last Name')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('EMAIL') }}</span>
                    <input type="email" v-model="email" :placeholder="$t('user123@gmail.com')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('PHONE') }}</span>
                    <input type="text" v-model="phone" @input="allowOnlyNumbers" :placeholder="$t('+1 234 5678 9012')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('ADDRESS') }}</span>
                    <input type="text" v-model="address" :placeholder="$t('Address')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('CITY') }}</span>
                    <input type="text" v-model="city" :placeholder="$t('City')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('COUNTRY') }}</span>
                    <select v-model="country">
                      <option value="" disabled>{{ $t('Country') }}</option>
                      <option v-for="item in countryOptions" :value="item.id" :key="item.id">{{ item.title }}</option>
                    </select>
                  </label>
                  <label>
                    <span class="desc">{{ $t('ZIP-CODE') }}</span>
                    <input type="text" v-model="postCode" :placeholder="$t('1234')"/>
                  </label>
                </div>

                <div v-if="availablePaymentMethods.length" class="checkout-methods">
                  <div class="checkout-methods__list">
                    <button
                      v-for="method in availablePaymentMethods"
                      :key="method.code"
                      type="button"
                      :class="['button black checkout-method-btn', { active: selectedPaymentMethod === method.code }]"
                      @click="selectedPaymentMethod = method.code"
                    >
                      <img v-if="method.image" :src="method.image" :alt="method.title || method.code" />
                      <span v-else>{{ method.title || method.code }}</span>
                    </button>
                  </div>
                </div>

                <div class="chekbox-container">
                  <label class="chekbox-label">
                    <div class="chekbox-label-wrapper">
                      <input v-model="terms" type="checkbox" name="terms">
                      <div class="checkbox" />
                      <span class="desc">{{ $t('I agree with') }} </span>
                      <a class="desc orange" @click="$parent.goToPage('privacy')">{{ $t('privacy policy') }}</a>
                      <span class="desc"> {{ $t('and') }} </span>
                      <a class="desc orange" @click="$parent.goToPage('terms')">{{ $t('terms and conditions') }}</a>
                    </div>
                  </label>
                </div>

                <div class="modal-bottom checkout-actions">
                  <!-- <div
                    v-if="canUseBalance"
                    :class="['button next-button', {'disabled': !requiredFieldsAreFilled || submitting}]"
                    @click="submit('balance')"
                  >
                    {{ submitting ? $t('PROCESSING...') : $t('PAY BY BALANCE') }}
                  </div> -->

                  <div :class="['button next-button', {'disabled': !requiredFieldsAreFilled || submitting}]" @click="submit(selectedPaymentMethod || primaryPaymentCode)">
                    {{ submitting ? $t('PROCESSING...') : primaryPaymentTitle }}
                  </div>
                </div>

                <transition name="fade">
                  <div class="desc error" v-if="error">{{ error }}</div>
                </transition>
                <transition name="fade">
                  <div class="desc success" v-if="success">{{ success }}</div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cartService from '@/cart'

const BILLING_STORAGE_KEY = 'checkout_billing_data'

export default {
  name: 'CheckoutModal',
  props: ['currency'],
  data() {
    return {
      countryOptions: [],
      name: '',
      surname: '',
      phone: '',
      email: '',
      address: '',
      city: '',
      country: '',
      postCode: '',
      terms: false,
      error: '',
      success: '',
      submitting: false,
      selectedPaymentMethod: '',
    }
  },
  computed: {
    totalAmount() {
      return cartService.state.totalAmount
    },
    requiredFieldsAreFilled() {
      return !!(
        this.name && this.surname && this.phone &&
        this.email && this.country && this.city &&
        this.address && this.postCode && this.terms
      )
    },
    primaryPaymentCode() {
      const methods = this.availablePaymentMethods
      return methods.length ? methods[0].code : 'card'
    },
    primaryPaymentTitle() {
      const methods = this.availablePaymentMethods
      if (!methods.length) return this.$t('PAY BY CARD')
      const selected = methods.find((m) => m.code === this.selectedPaymentMethod)
      const method = selected || methods[0]
      return method.title ? method.title.toUpperCase() : this.$t('PAY BY CARD')
    },
    availablePaymentMethods() {
      const methods = this.$parent && this.$parent.settings && Array.isArray(this.$parent.settings.payment_methods)
        ? this.$parent.settings.payment_methods
        : []
      const currentCurrency = this.$parent?.currencyCode || this.currency || ''
      return methods.filter((method) => {
        if (!Array.isArray(method.currencies) || !method.currencies.length) return true
        return method.currencies.includes(currentCurrency)
      })
    },
    selectedPaymentMethodObject() {
      return this.availablePaymentMethods.find((m) => m.code === this.selectedPaymentMethod) || null
    },
    canUseBalance() {
      const settings = this.$parent && this.$parent.settings ? this.$parent.settings : {}
      return !!settings.credits_enabled
    },
    hasSufficientBalance() {
      const profile = this.$parent && this.$parent.profileData ? this.$parent.profileData : {}
      const balance = profile.balance || 0
      return balance >= parseFloat(this.totalAmount || 0)
    }
  },
  mounted() {
    this.getCountries()
    this.prefillBillingData()
    if (!this.selectedPaymentMethod && this.availablePaymentMethods.length) {
      this.selectedPaymentMethod = this.availablePaymentMethods[0].code
    }
  },
  watch: {
    availablePaymentMethods(methods) {
      if (!methods.length) {
        this.selectedPaymentMethod = ''
        return
      }
      const exists = methods.some((m) => m.code === this.selectedPaymentMethod)
      if (!exists) {
        this.selectedPaymentMethod = methods[0].code
      }
    }
  },
  methods: {
    allowOnlyNumbers() {
      this.phone = this.phone.replace(/[^0-9+\- ]/g, '')
    },
    prefillBillingData() {
      this.$http.get(process.env.VUE_APP_API + 'user/profile')
        .then((res) => {
          const data = (res.data && res.data.payload) ? res.data.payload : {}
          const localData = this.getSavedBillingData()

          this.name = localData.first_name || data.name || ''
          this.surname = localData.last_name || data.surname || ''
          this.phone = localData.phone || data.phone || ''
          this.email = localData.email || data.email || ''
          this.address = localData.address || data.address || ''
          this.city = localData.city || data.city || ''
          this.postCode = localData.zip || data.zip || ''
          this.country = localData.country_id || data.country_id || ''
        })
        .catch(() => {
          const localData = this.getSavedBillingData()
          this.name = localData.first_name || ''
          this.surname = localData.last_name || ''
          this.phone = localData.phone || ''
          this.email = localData.email || ''
          this.address = localData.address || ''
          this.city = localData.city || ''
          this.postCode = localData.zip || ''
          this.country = localData.country_id || ''
        })
    },
    getSavedBillingData() {
      try {
        const raw = localStorage.getItem(BILLING_STORAGE_KEY)
        return raw ? JSON.parse(raw) : {}
      } catch (e) {
        return {}
      }
    },
    saveBillingData(data) {
      try {
        localStorage.setItem(BILLING_STORAGE_KEY, JSON.stringify(data))
      } catch (e) {
        // Ignore write errors (private mode / quota exceeded)
      }
    },
    getCountries() {
      this.$http.get(process.env.VUE_APP_API + 'countries')
        .then((res) => {
          this.countryOptions = res.data.payload || []
        })
        .catch(() => {})
    },
    async submit(paymentType) {
      if (!this.requiredFieldsAreFilled) return
      if (paymentType === 'balance' && !this.hasSufficientBalance) {
        const message = this.$t('Not enough balance')
        this.error = message
        cartService.showToast(message, 'error')
        return
      }

      this.error = ''
      this.success = ''
      this.submitting = true

      const payload = {
        first_name: this.name,
        last_name: this.surname,
        phone: this.phone,
        email: this.email,
        country_id: this.country,
        city: this.city,
        address: this.address,
        zip: this.postCode,
        paymentType,
      }

      this.saveBillingData(payload)
      const result = await cartService.purchaseCart(payload)

      if (result.success) {
        if (result.redirect) {
          window.location = result.redirect
          return
        }

        this.success = this.$t('Purchase successful!')
        if (this.$parent.getProfileData) {
          this.$parent.getProfileData()
        }
        setTimeout(() => {
          this.$parent.closeCheckoutModal()
          this.$router.push('/history')
        }, 1500)
      } else {
        if (result.status === 401) {
          this.$parent.openSignInModal()
        }
        this.error = result.message || this.$t('Checkout failed')
      }

      this.submitting = false
    },
  }
}
</script>

<style scoped>
.checkout-wrapper {
  max-height: 90vh;
  overflow-y: auto;
}

.checkout-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.checkout-head__side {
  flex: 1;
}

.checkout-head__title {
  flex: 1;
  text-align: center;
}

.checkout-head__total {
  text-align: right;
}

.checkout-total {
  color: #cd3c3c;
}

.checkout-actions {
  gap: 12px;
}

.checkout-actions .button {
  width: 100%;
}

.checkout-methods {
  margin-top: 10px;
}

.checkout-methods__list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 6px;
}

.checkout-method-btn {
  min-width: 140px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
}

.checkout-method-btn img {
  max-height: 20px;
  width: auto;
}

.checkout-method-btn.active {
  background-color: #FFBB0E;
}

</style>
